import { Link } from '@mui/material'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { routePaths } from './route-paths'
import { prepareRoutes } from './utils/prepareRoutes'

export const useOpenEnrollmentsRoutes = () => {
	const { b4b_32681_oewindowupdates: isOeWindowUpdatesEnabled } = useFlags()

	return prepareRoutes(
		[
			{
				path: routePaths.openEnrollments.root,
				lazy: () =>
					isOeWindowUpdatesEnabled
						? import('pages/open-enrollments/open-enrollments').then((module) => ({
								Component: module.OpenEnrollmentsPage,
							}))
						: import('pages/open-enrollments/open-enrollments-legacy').then((module) => ({
								Component: module.OpenEnrollmentsPageLegacy,
							})),
				handle: {
					crumb: () => <Link href={routePaths.openEnrollments.root}>Open Enrollments</Link>,
				},
			},
		],
		{},
	)
}
